import { Injectable }       from '@angular/core';

import { Observable }                                        from 'rxjs/Observable';
import { Subject }                                           from 'rxjs/Subject';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';

import * as firebase  from 'firebase';
import { Holidays }   from './Holidays';
import * as models    from '../models/models';

const DEFAULT_RTTL = "Adams Family:o=5,d=8,b=160,b=160:c,4f,a,4f,c,4b4,2g,f,4e,g,4e,g4,4c,2f,c,4f,a,4f,c,4b4,2g,f,4e,c,4d,e,1f,c,d,e,f,1p,d,e,f#,g,1p,d,e,f#,g,4p,d,e,f#,g,4p,c,d,e,f";

@Injectable()
export class StamplingDB {
  config: any = {
        "apiKey": "AIzaSyCp5bO6p8KQ-9ERYeIFvI0XyL9GFz5lpDU",
        "authDomain": "stampling-machine.firebaseapp.com",
        "databaseURL": "https://stampling-machine.firebaseio.com/",
        "storageBucket": "stampling-machine.appspot.com"
    };

  logged_in: models.FirebaseUser = null;
  logged: Subject<models.FirebaseUser> = new Subject<models.FirebaseUser>();

  constructor(private holidays: Holidays) {
    firebase.initializeApp(this.config);
  }

  load() {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        var email = user.email;
        this.loadLoggedUser(email);
      } else {
        this.logged_in=null;
        this.logged.next();
      }
    });
  }

  subscribeLogin(): Observable<models.FirebaseUser> {
    return this.logged.asObservable();
  }

  getLoggedUser(): models.FirebaseUser {
    return this.logged_in;
  }

  login(email: string, password: string): Promise<models.FirebaseUser> {
    return firebase
        .auth()
        .signInWithEmailAndPassword(email, password)
        .then((u) => this.loadLoggedUser(email));
  }

  loadLoggedUser(email: string) : Promise<models.FirebaseUser> {
    return firebase.database().ref('/users')
        .orderByChild('email')
        .equalTo(email)
        .once('value')
        .then((res) =>  {
          let data = res.val()
          for (let i in data) {
            if (data[i].email!=null && data[i].email==email) {
              let role: string = "USER";
              switch (data[i].role) {
                case "cto":
                case "admin":
                  role = data[i].role.toUpperCase();
                  break;
              }
              let rtttl = DEFAULT_RTTL;
              if (data[i].tone!=undefined) rtttl = data[i].tone;
              let user: models.FirebaseUser = {
                id: i,
                email: email,
                name: data[i].name,
                role: role,
                is_manager: role!="USER",
                group: data[i].group,
                workday: data[i].workday!=undefined ? parseInt(data[i].workday) : 8,
                tone: rtttl};
              this.logged_in = user;
              this.logged.next(user);
              console.log(user)
              return user;
            }
          }
          throw "not a valid user";
        })
  }

  logout() {
    if (this.getLoggedUser()!=null) firebase.auth().signOut();
  }

  getAllowedUsers(): Promise<models.StamplingUser[]> {
    let u = this.getLoggedUser();
    if (u==null || u.email=="") return new Promise((res, err) => err("You must login"));

    return firebase.database()
        .ref('/users').once('value')
        .then((res) => {
          let all: models.StamplingUser[] = []
          let data = res.val()

          for (let i in data) {
            let s: models.StamplingUser = {
              id: i,
              name: data[i].name,
              email: data[i].email,
              cardid: data[i].cardid,
              group: data[i].group,
              workday: data[i].workday!=undefined ? parseInt(data[i].workday) : 8,
            };
            if (s.cardid!=null && s.cardid!="none") {
              if (!u.is_manager && s.email==u.email) return [s];
              if (u.role==models.UserRoles.CTO.toString()) {
                if (u.group==s.group || s.group=="TEST") all.push(s)
              } else {
                all.push(s)
              }
            }
          }
          return all;
        });
  }

  findStampling(user: models.StamplingUser, year: number, month: number): Promise<models.DailyStampling[]> {
    let holidays: Date[] = this.holidays.getHolidays(year, month);

    let r: string = this._path_month(user.cardid, year, month);
    return firebase.database().ref(r)
      .once('value')
      .then((r) => r.val())
      .then((res) => {
          let dates: models.DailyStampling[] = [];
          let lastDay = new Date(year, month+1, 0, 12, 0).getDate()
          for (var i=1; i<=lastDay; i++) {
            let d = new Date(year, month, i, 12, 0);
            if (d.getMonth()==month) {
              let weekend: boolean = d.getDay()==0 || d.getDay()==6
              if (!weekend) {
                for (let j in holidays) {
                  if (holidays[j].getDate()==d.getDate()) {
                    weekend=true;
                    break;
                  }
                }
              }
              dates.push({user:user, date: d, holiday: weekend, times: []});
            }
          }
          for (let day in res) {
            let times = res[day];
            let index: number = parseInt(day)-1;
            for (let i in times) {
              let r = times[i]
              let d = new Date(r.datetime);
              let s : models.Stampling = {datetime: d, id: i, hour: d.getHours(), minute: d.getMinutes(), is_artifact: false};
              if (index<dates.length) {
                dates[index].times.push(s);
                dates[index].times.sort((s1, s2) => s1.datetime.getTime()-s2.datetime.getTime())
              }
            }

          }

          for (var i=0; i<dates.length; i++) {
            let times = dates[i].times;
            //console.log(i, times);
            if (times.length>=1) dates[i].entrance = times[0];
            if (times.length>=2) dates[i].exit = times[times.length-1];
            if (times.length==3) {
              dates[i].start_pause = times[1]
              var endH: number = times[1].hour+1;
              var endM: number = times[1].minute;

              if (endH>=dates[i].exit.hour) {
                dates[i].end_pause = dates[i].exit
                dates[i].exit = null;
              } else {
                let datetime: Date = new Date(dates[i].date);
                datetime.setHours(endH);
                datetime.setMinutes(endM);
                dates[i].end_pause = {datetime:datetime, id: null, hour:endH, minute:endM, is_artifact: true};
              }
            }
            if (times.length>=4) {
              dates[i].start_pause = times[1]
              dates[i].end_pause = times[times.length-2]
            }
          }
          //console.log(dates);
          return dates;
        });
  }

  deleteStampling(cardid: string, s: models.Stampling): Promise<Object> {
    let r: string = this._path_date(cardid, s.datetime)+s.id;
    console.log("removing: ", r)

    return firebase.database().ref(r).remove();
  }

  saveStampling(cardid: string, date: Date): Promise<Object> {
    let d: models.RawStampling = this._format_stampling(date).value;
    return firebase.database().ref(this._path_date(cardid, date)+d.time).set(d);
  }

  saveStamplings(cardid: string, y: number, m: number, dates: Date[]): Promise<Object> {
    let stamplings: any = {}
    for (let i=0; i<dates.length; i++) {
      let date: Date = dates[i];
      console.log(date, y, m);
      if (date.getFullYear()==y && date.getMonth()==m) {
        let d = this._format_stampling(date);
        if (stamplings[d.key]==undefined) stamplings[d.key]={}
        stamplings[d.key][d.value.time] = d.value;
      }
    }
    console.log(stamplings);
    return firebase.database().ref(this._path_month(cardid, y, m)).set(stamplings);
  }

  _format_stampling(date: Date) {
    let d: string = this._day_str(date);
    let datetime: string = this._datetime_str(date);
    return {"key":d, "value": {"datetime": datetime, "time": this._time_str(date)}};
  }
  _path_date(cardid: string, d: Date) {
    return "/stampling/"+cardid+"/"+this._year_str(d)+"/"+this._month_str(d)+"/"+this._day_str(d)+"/";
  }
  _path_month(cardid: string, y: number, m: number) {
    return "/stampling/"+cardid+"/"+this._pad(y, 4, "0")+"/"+this._pad(m+1, 2, "0")+"/";
  }
  _year_str(d: Date) {
    return this._pad(d.getFullYear(), 4, "0");
  }
  _month_str(d: Date) {
    return this._pad(d.getMonth()+1, 2, "0");
  }
  _day_str(d: Date) {
    return this._pad(d.getDate(), 2, "0");
  }
  _time_str(d: Date, s?: number, milli?: number) {
    let t: string = this._pad(d.getHours(), 2, "0")+":"+this._pad(d.getMinutes(), 2, "0");
    if (s!=undefined) {
      t+=":"+this._pad(s, 2, "0");
      if (milli!=undefined) {
        t+="."+this._pad(milli, 3, "0");
      }
    }
    return t;
  }
  _date_str(d: Date) {
    return this._year_str(d)+"-"+this._month_str(d)+"-"+this._day_str(d);
  }
  _datetime_str(d: Date) {
    return this._date_str(d)+"T"+this._time_str(d, 0);
  }

  _pad(num: number, size: number, lead: string): string {
    let s: string = num+"";
    while (s.length < size) s = lead + s;
    return s;
  }

  saveTone(userId: string, tone: string) {
    let r: string = "/users/"+userId+"/tone";
    return firebase.database().ref(r).set(tone);
  }

  saveWorkingHours(userId: string, hours: number) {
    let r: string = "/users/"+userId+"/workday";
    return firebase.database().ref(r).set(hours);
  }
}



// WEBPACK FOOTER //
// /builds/mediaclinicstn/stampling-viewer/src/providers/StamplingDB.ts